import { fg } from '@atlassian/jira-feature-gating';
import {
	getAllIssues,
	getIsIssuesLoading,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export const getAssociatedIssueIds = createSelector(
	[getIsIssuesLoading, getAllIssues],
	(isIssuesLoading, issues) =>
		isIssuesLoading && fg('polaris-arj-png-export-bugfix')
			? undefined
			: issues.map((issue) => issue.associatedIssueIds || []).flat(),
);
